<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/admin">Ma boutique</router-link>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/register" tag="li">
              <a>Créer un compte</a>
            </router-link>
            <!-- <router-link to="/admin/overview" tag="li">
              <a>Dashboard</a>
            </router-link> -->
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Connexion</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Adresse email</label>
                        <input v-model="email" type="email" placeholder="Entrez votre email" class="form-control input-no-border">
                      </div>
                      <div class="form-group">
                        <label>Mot de passe</label>
                        <input v-model="password" type="password" placeholder="Entrez votre mot de passe" class="form-control input-no-border">
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button @click="login" class="btn btn-fill btn-wd ">Connexion</button>
                      <div class="forgot">
                        <router-link to="/register">
                          Mot de passe oublié ?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Coded with
              <i class="fa fa-heart heart"></i> by
              <a href="https://github.com/cristijora" target="_blank">Cristi Jora</a>.
              Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>.
            </div>
          </div>
        </footer> -->
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Créer un compte</a>
        </router-link>
        <!-- <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link> -->
      </ul>
    </div>
  </div>
</template>
<script>
  import firebase from 'firebase'
  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login () {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            this.$router.push('/')
          })
          .catch((error) => {
            let message = ''
            switch (error.code) {
              case 'auth/wrong-password':
                message = 'Le mot de passe est incorrect'
                break
              case 'auth/user-not-found':
                message = `Il n'y a pas d'utilisateur enregistré avec cette adresse email`
                break
              default:
                console.error(error)
                message = error.message
            }
            this.$notify({
              component: {
                template: `<span>${message}</span>`
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning'
            })
          })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue